import React from 'react'
import {graphql} from 'gatsby'

import GraphQLErrorList from '../components/graphql-error-list'
import Container from '../components/container'
import Layout from "../components/layout"
import Seo from "../components/seo"
import Gallery from '../components/gallery'
import {Link} from 'gatsby'
import SimpleReactLightbox from "simple-react-lightbox"
import PortableText from '../components/portableText'
import ReactPlayer from 'react-player'
import { FaExternalLinkAlt } from "react-icons/fa"
import {buildImageObj, getStudentUrl} from '../lib/helpers'
import {imageUrlFor} from '../lib/image-url'
import { IoMdArrowBack } from "react-icons/io"

import "../components/style/art-work.css"

import { navigate } from "@reach/router";

const goBack = () => {
navigate(-1);
}



export const query = graphql`
  fragment SanityImage on SanityMainImage {
    crop {
      _key
      _type
      top
      bottom
      left
      right
    }
    hotspot {
      _key
      _type
      x
      y
      height
      width
    }
    asset {
      _id
    }
  }

  query ArtWorkQuery($id: String!) {   
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      academicYear {
        title
      }
      link
      instagramLink
      departmentTitle
      universityTitle
      universityAddress
      description
      keywords
    }
    
    artWork: sanityArtWork( id: {eq: $id}) {
      academicYear {
        title
      }
      id
      embed
      title
      video {
        url
      }
      webLink
      pdf {
        title
        file {
          asset {
            url
          }
        }
      }
      slug {
        current
      }
      authors {
        roles
        name
        slug {
          current
        }
      }
      _rawDescription
      images {
        ...SanityImage
        alt
      }
      thumbnail {
        asset {
          _id
        }
        crop {
          _key
          _type
          bottom
          left
          right
          top
        }
        hotspot {
          _key
          _type
          height
          width
          x
          y
        }
      }
    }
  }
`

const ArtWork = props => {
const {data, errors} = props

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }

  const site = (data || {}).site

  const artWork = (data || {}).artWork

  if(artWork.thumbnail && artWork.thumbnail.asset !== null){
      let img = imageUrlFor(buildImageObj(artWork.thumbnail))
              .width(800)
              .height(800)
              .fit('crop')
              .url()
      artWork.imgurl = img;
    }

  return (
    <SimpleReactLightbox>
    <Layout link={site.link} academicYear={site.academicYear.title} description={site.description} departmentTitle={site.departmentTitle} universityTitle={site.universityTitle} universityAddress={site.universityAddress} instagramLink={site.instagramLink}>
      <Seo
        title={artWork.title}
        description={site.description}
        keywords={site.keywords}
      />
      <Container>
        
        <div className="main-content dark-mode art-work">
          <div className="pusher wrapper">
            
            <div className="grid">
              <div className="width-4-12 width-12-12-m sidebar">
                
                <h4 className="head">{props.location.state && props.location.state && <><a onClick={goBack} className="back-link"><IoMdArrowBack /> </a></>}Artwork</h4>
                <h1>{artWork.title}</h1>
                <ul className="authorlist">
                  {artWork.authors && artWork.authors.map(author => {
                    return author.roles && author.roles[0] === 'student' && (
                      <li key={artWork.id}>
                        <Link to={getStudentUrl(author.slug)}>
                          {author.name}
                        </Link>
                      </li>
                    )
                  })}

                  {artWork.authors && artWork.authors.map(author => {
                    return author.roles && author.roles[0] !== 'student' && (
                      <li key={artWork.id}>
                          {author.name}
                      </li>
                    )
                  })}
                </ul>

                {artWork._rawDescription && 
                    <div className="description">
                    <PortableText blocks={artWork._rawDescription}/>
                    </div>
                  }
            
                {artWork.webLink && 
                  <p className="extras"><a href={artWork.webLink} rel="noopener noreferrer" target="_blank">Web Project</a> <FaExternalLinkAlt /></p>
                }

                {artWork.pdf && artWork.pdf.file && 
                  <>
                  <p className="extras"><a href={artWork.pdf.file.asset.url} rel="noopener noreferrer" target="_blank">{artWork.pdf.title} (pdf) <FaExternalLinkAlt /></a></p>
                  </>
                }
              </div>
              <div className="width-8-12 width-12-12-m">

                  {artWork.embed && 
                    <div className="embed">
                    <iframe src={artWork.embed} 
                            title="artwork embed"
                            width="100%" 
                            height="480"
                            seamless="seamless" 
                            scrolling="no" 
                            frameBorder="0" 
                            allowFullScreen>
                    </iframe>
                    </div>
                  }

                  {artWork.images &&  (
                  <Gallery
                      images={artWork.images}
                    />
                  )}

                  {artWork.video && artWork.video.url && (
                    <>
                        <div className="video-holder">
                        <div className='player-wrapper'>
                          <ReactPlayer 
                            className='react-player'
                            url={artWork.video.url}
                            width='100%'
                            height='100%'
                          />
                        </div>
                        </div>
                    </>
                    )}

                  {artWork.images.length === 0 && artWork.embed == null && artWork.video == null &&
                    artWork.imgurl && (
                      <div className="grid">
                        <div className="width-6-12-m width-4-12">
                          <div className="gallery-image">
                            <img src={artWork.imgurl} title={artWork.title} alt={artWork.title} />
                          </div>
                        </div>
                      </div>
                  )}

              </div>
            </div>
          

          </div>

        </div>

      </Container>
    </Layout>
    </SimpleReactLightbox>
  )
}

export default ArtWork